import loadable from '@loadable/component';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "__new-topic-takeover" */
      './NewTopicMain'
    ),
);
